module.exports = __webpack_public_path__ + "img/cabinet-osteo-barry.72e7c1b5.jpg";